import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function PolitiqueConfidentialite() {
  return (
    <main>
      <Navbar />

      <section className="pt-40 pb-24 bg-white">
        <div className="max-w-3xl mx-auto px-8 lg:px-6">
          <span className="font-sans text-xs tracking-widest uppercase text-brand-gris-light">
            Légal
          </span>
          <h1 className="font-serif font-light text-brand-noir text-5xl lg:text-6xl mt-5 mb-16 leading-tight">
            Politique de confidentialité
          </h1>

          {/* Company info block */}
          <div className="border-l-4 border-brand-or bg-brand-beige px-8 py-6 mb-14 font-mono text-sm text-brand-gris leading-loose">
            <strong className="text-brand-noir not-italic font-sans font-medium tracking-wider">MARCINSKI</strong><br />
            Oskar Arkadiusz Marcinski<br />
            SIRET : 101 116 994 00019<br />
            37 Rue Lecocq, 33000 Bordeaux, France
          </div>

          <div className="space-y-12 font-sans font-light text-[#333] text-base leading-loose">
            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-1" id="article-1">1. Données collectées</a>
              </h2>
              <p>
                Dans le cadre de l'utilisation du formulaire de contact, le site peut collecter les données
                personnelles suivantes :
              </p>
              <ul className="mt-4 space-y-2 list-none pl-0">
                {["Nom", "Adresse email", "Numéro de téléphone", "Message / description du projet"].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-or flex-shrink-0"></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-2" id="article-2">2. Finalité de la collecte</a>
              </h2>
              <p>
                Ces données sont collectées et utilisées uniquement dans le but de répondre aux demandes
                et messages envoyés via le formulaire de contact. Elles ne font l'objet d'aucune autre
                utilisation commerciale ou marketing.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-3" id="article-3">3. Conservation des données</a>
              </h2>
              <p>
                Les données personnelles sont conservées pour la durée strictement nécessaire au traitement
                de la demande, dans la limite des obligations légales applicables.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-4" id="article-4">4. Partage des données</a>
              </h2>
              <p>
                Aucune donnée personnelle n'est vendue, louée ou partagée avec des tiers à des fins
                commerciales. Les informations collectées restent strictement confidentielles.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-5" id="article-5">5. Vos droits</a>
              </h2>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
                Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement
                et de portabilité de vos données personnelles.
              </p>
              <p className="mt-4">
                Pour exercer ces droits ou pour toute question relative à la protection de vos données,
                contactez-nous via la page <a href="/contact" className="text-brand-or underline">Contact</a>.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-6" id="article-6">6. Cookies</a>
              </h2>
              <p>
                Ce site peut utiliser des cookies techniques nécessaires à son fonctionnement. Aucun
                cookie à des fins publicitaires ou de tracking n'est utilisé.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-7" id="article-7">7. Droit applicable</a>
              </h2>
              <p>
                La présente politique de confidentialité est soumise au droit français et au règlement
                européen RGPD n°2016/679 du 27 avril 2016.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
